import { normalizeLocale, type SupportedLocale } from '@/i18n/config';
import catalog from '@/i18n/generated/legal-page-locales.json';

type LegalPageCatalog = Partial<
  Record<SupportedLocale, Record<string, string>>
>;

const legalPageCatalog = catalog as LegalPageCatalog;

export function normalizeLegalCopy(value: string): string {
  return value.replace(/\s+/g, ' ').trim();
}

export function translateLegalCopy(locale: string, value: string): string {
  const normalized = normalizeLegalCopy(value);
  if (!normalized) return value;
  const translations = legalPageCatalog[normalizeLocale(locale)];
  return (
    translations?.[normalized] ??
    translations?.[normalized.replaceAll("'", '’')] ??
    value
  );
}
